import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { UsersService } from '../../users/users.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HeaderService } from './header.service';
import { NavigationService } from '../services/navigation.service';
import { DeviceManagementService } from 'src/app/device/device-management.service';
import { CommonService } from '../services/common.service';
import { LeftPanelService } from '../left-panel/left-panel.service';
import { Subscription } from 'rxjs';
import { DomainsService } from '../services/domains.service';
import { CommonDataService } from '../services/common-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
	@Input() visibleSideMenu: boolean;
	@Input() isFullSize: boolean = false;

	isMobileOrTablet: boolean = false;

	leftMenuSub: Subscription = new Subscription();
	user: any = {};
	showHeader = false;
	isProduction: boolean = false;
	isStaging: boolean = false;
	hideHeader: boolean = true;
	showBanner = false;
	siteName: string = '';
	headerLogo: string = '';

	searchString = '';
	searchType = 'normal-search';
	searchDevicesResult: any = {};
	@ViewChild('searchInput') searchInput: ElementRef;

	constructor(
		public usersService: UsersService,
		public header: HeaderService,
		private router: Router,
		private navigation: NavigationService,
		private deviceManagementService: DeviceManagementService,
		public commonService: CommonService,
		private commonDataService: CommonDataService,
		private sideMenuService: SideMenuService,
		private route: ActivatedRoute,
		private leftPanelService: LeftPanelService,
		private domainsService: DomainsService,
		private translate: TranslateService
	) { }

	ngOnInit() {
		this.checkWindowSize();
		this.updateHeaderLogo();
		this.isProduction = this.domainsService.isProductionDomain;
		this.isStaging = this.domainsService.isStagingDomain;
		this.showBanner = !this.domainsService.isSmartTelemetrics && !this.domainsService.isFred;
		this.siteName = this.translate.instant('g.iotah');

		if (this.domainsService.isChargLink)
			this.siteName = this.translate.instant('g.charglink');

		if (this.domainsService.isBattlink)
			this.siteName = this.translate.instant('g.battlink');

		if (this.domainsService.isFred)
			this.siteName = this.translate.instant('g.fred');

		this.usersService.currentUser.subscribe((user: any) => {
			if (user && Object.keys(user).length > 0) {
				this.user = user;
			}
		});
		this.usersService.getCurrentUser();
		this.header.toggleSearchBox(this.header.SearchBoxVisible);
		this.hideHeader = this.route.snapshot.firstChild?.data.hideItems;

		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.hideHeader = this.route.snapshot.firstChild?.data.hideItems;
			}
		});

		this.leftMenuSub = this.leftPanelService.leftPanelVisibility.subscribe(v=> {
			this.isFullSize = !v;
		});
	}

	updateHeaderLogo() {
		if(this.domainsService.isChargLink)
			return this.headerLogo = 'brand-logo-charglink';

		if(this.domainsService.isIotah)
			return this.headerLogo = 'brand-logo-iotah';

		if(this.domainsService.isBattlink)
			return this.headerLogo = 'brand-logo-battlink';

		if(this.domainsService.isFred)
			return this.headerLogo = 'brand-logo-fred';

		return this.headerLogo = 'brand-logo ml-4';
	}

	logout() {
		this.usersService.logout().subscribe((done: boolean) => {
			this.navigation.setPreviousUrl(null, true);
			this.usersService.setCurrentUser({});
			this.sideMenuService.setData([]);
			this.router.navigate(['/login']);
		});
	}

	toggleHeader() {
		this.showHeader = !this.showHeader;
	}

	closeMobileHeader() {
		this.showHeader = false;
	}

	userHasAdminLogsTab() {
		return (
			this.usersService.hasAccessFunction('search_users') ||
			this.usersService.hasAccessFunction('registration_requests') ||
			this.usersService.hasAccessFunction('admin_contact_us') ||
			this.usersService.hasAccessFunction('access_error_logs') ||
			this.usersService.hasAccessFunction('access_action_logs') ||
			this.usersService.hasAccessFunction('access_rejection_logs') ||
			this.usersService.hasAccessFunction('sched_functions_control') ||
			this.usersService.hasAccessFunction('add_device') ||
			this.usersService.hasAccessFunction('dev_team') ||
			this.usersService.hasAccessFunction('site_management') ||
			this.usersService.hasAccessFunction('device_management') ||
			this.user.is_admin
		);
	}

	enableFullAccessMode() {
		this.usersService.enableFullAccessMode().subscribe(
			(data) => {
				this.usersService.updateCurrentUser(data);
				window.location.reload();
			}
		);
	}

	searchDevices() {
		try {
			JSON.parse(this.searchString);
		} catch (ex) {
			this.searchString = this.searchString.trim().replace(/:/g, "");
		}

		let searchBy = 'sn';
		if (/^[a-fA-F0-9]{12}$/.test(this.searchString))
			searchBy = 'mac';
		if (/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(this.searchString))
			searchBy = 'ip'

		if (!this.searchString)
			return;

		this.deviceManagementService.searchDevices(this.searchString, searchBy, false, 'no', this.searchType).subscribe((data: any) => {
			let devicePath = [];
			let sitePath = [];
			if (data.devices.length == 1) {
				let device = data.devices[0];
				if (data.sites && data.sites[device.site_id] && !device.is_deleted) {
					let customerId = data.sites[device.site_id].customer_id;
					devicePath = ['/', customerId, device.site_id, device.mac_address, 'performance'];
					sitePath = ['/', customerId, device.site_id];
				}
			}
			if (devicePath.length) {
				this.router.navigate(sitePath).then(() => {
					this.router.navigate(devicePath);
				});
			} else {
				if (/^[a-fA-F0-9]{6,12}$/.test(this.searchString)) {
					//Detect (partial) search type
					searchBy = 'mac';
				}
				this.router.navigate(
					['/device/search'],
					{
						queryParams: {
							searchString: this.searchString,
							searchBy
						}
					}
				);
			}
		});
	}

	checkWindowSize() {
		this.isMobileOrTablet =  window.innerWidth < this.commonDataService.tabletWidth;
	}
}
